/**
 * Open-source stub — API key deletion not available in local mode.
 */
export default async function deleteApiKey(_keyId: string): Promise<void> {
  console.warn("API key management requires Cognee Cloud.");
}
